import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right-thin",
  "use": "icon-chevron-right-thin-usage",
  "viewBox": "0 0 16 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 28\" id=\"icon-chevron-right-thin\">\n<polygon id=\"icon-chevron-right-thin_Page-1\" points=\"1.4,0 0,1.4 12.9,14 12.9,14 12.9,14 0,26.6 1.4,28 14.3,15.4 15.8,14 15.8,14 15,13.2 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/chevron-right-thin.svg
// module id = 117
// module chunks = 0 1 2